import dayjs from "dayjs";

import { Modal } from "antd";
import { useCalendarIssues } from "../../context";
import MultipleItems from "./components/MultipleItems";

const ConfirmModal = () => {
  const {
    view_type,
    draggable_event,
    setDraggableEvent,
    handleConfirmDragIssue,
    handleConfirmDragTask,
  } = useCalendarIssues();
  if (draggable_event?.event?.type === "multiple") {
    const issues = draggable_event.event.issues;
    const tasks = draggable_event.event.tasks;
    const format = view_type === "day" ? "HH:mm" : "DD-MM-YYYY HH:mm";
    return (
      <MultipleItems
        date={draggable_event?.date}
        is_open={!!draggable_event?.event?.event_id}
        issues={issues}
        tasks={tasks}
        format={format}
        setDraggableEvent={setDraggableEvent}
        handleConfirmDrag={(id, type) =>
          type === "issue"
            ? handleConfirmDragIssue(id)
            : handleConfirmDragTask(id)
        }
      />
    );
  }
  if (draggable_event?.event?.type === "issue") {
    const issue = draggable_event.event.issues[0];
    const format = view_type === "day" ? "HH:mm" : "DD-MM-YYYY HH:mm";
    return (
      <Modal
        style={{ top: 45 }}
        title="Potwierdzenie"
        open={!!draggable_event?.event?.event_id}
        onOk={() => handleConfirmDragIssue(issue.id)}
        onCancel={() => setDraggableEvent(null)}
        cancelText="Anuluj"
        okText="Potwierdzam"
      >
        Czy na pewno chcesz zmienić datę umówienia dla zgłoszenia <br />
        <strong>{issue?.client_address}</strong> <br />z{" "}
        <strong>{dayjs(issue?.service_date).format(format)}</strong>
        <br />
        na <strong>{dayjs(draggable_event?.date).format(format)}</strong>?
      </Modal>
    );
  }
  if (draggable_event?.event?.type === "task") {
    const task = draggable_event.event.tasks[0];
    return (
      <Modal
        style={{ top: 45 }}
        title="Potwierdzenie"
        open={!!draggable_event?.event?.event_id}
        onOk={() => handleConfirmDragTask(task.id)}
        onCancel={() => setDraggableEvent(null)}
        cancelText="Anuluj"
        okText="Potwierdzam"
      >
        Czy na pewno chcesz przenieść priorytet <br />
        <strong>{task?.content}</strong> <br />z{" "}
        <strong>{dayjs(task?.date).format("DD-MM-YYYY HH:mm")}</strong> <br />
        na{" "}
        <strong>
          {dayjs(draggable_event?.date).format("DD-MM-YYYY HH:mm")}
        </strong>
        ?
      </Modal>
    );
  }
};

export default ConfirmModal;
